webpackJsonp([3],{

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WithHover = function WithHover(WrappedComponent) {
  var WrappedComponentWithHover = function (_React$Component) {
    _inherits(WrappedComponentWithHover, _React$Component);

    function WrappedComponentWithHover(props) {
      _classCallCheck(this, WrappedComponentWithHover);

      var _this = _possibleConstructorReturn(this, (WrappedComponentWithHover.__proto__ || Object.getPrototypeOf(WrappedComponentWithHover)).call(this, props));

      _this.onMouseOver = _this.onMouseOver.bind(_this);
      _this.onMouseOut = _this.onMouseOut.bind(_this);
      _this.state = {
        hover: false
      };
      return _this;
    }

    _createClass(WrappedComponentWithHover, [{
      key: 'onMouseOver',
      value: function onMouseOver() {
        this.setState({ hover: true });
        if (this.props.onMouseOver) {
          this.props.onMouseOver();
        }
      }
    }, {
      key: 'onMouseOut',
      value: function onMouseOut() {
        this.setState({ hover: false });
        if (this.props.onMouseOut) {
          this.props.onMouseOut();
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(WrappedComponent, _extends({}, this.props, {
          isHover: this.state.hover,
          onMouseOver: this.onMouseOver,
          onMouseOut: this.onMouseOut
        }));
      }
    }]);

    return WrappedComponentWithHover;
  }(_react2.default.Component);

  WrappedComponentWithHover.defaultProps = {
    onMouseOut: function onMouseOut() {},
    onMouseOver: function onMouseOver() {}
  };
  WrappedComponentWithHover.propTypes = {
    onMouseOut: _propTypes2.default.func,
    onMouseOver: _propTypes2.default.func
  };

  return WrappedComponentWithHover;
};

exports.default = WithHover;

/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SidebarDownloadDocButton = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WithHover = __webpack_require__(124);

var _WithHover2 = _interopRequireDefault(_WithHover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SidebarDownloadDocButton = exports.SidebarDownloadDocButton = function SidebarDownloadDocButton(props) {
  var imgSrc = props.isHover ? props.imgSrcHover : props.imgSrc;
  var slug = props.slug,
      format = props.format;

  var linkProps = {
    target: '_blank',
    rel: 'noreferrer noopener',
    href: window.formswiftUrl + '/downloads/' + slug + '/' + slug + '.' + format
  };
  if (format !== 'pdf') {
    linkProps.download = true;
  }
  return _react2.default.createElement(
    'div',
    {
      className: 'rank-brain-2-sidebar-download-doc-button',
      onMouseOver: props.onMouseOver,
      onMouseOut: props.onMouseOut
    },
    _react2.default.createElement(
      'a',
      linkProps,
      _react2.default.createElement('img', { alt: 'Download', src: imgSrc }),
      props.text
    )
  );
};

SidebarDownloadDocButton.defaultProps = {
  isHover: false
};

SidebarDownloadDocButton.propTypes = {
  isHover: _propTypes2.default.bool,
  imgSrc: _propTypes2.default.string.isRequired,
  imgSrcHover: _propTypes2.default.string.isRequired,
  text: _propTypes2.default.string.isRequired,
  onMouseOver: _propTypes2.default.func.isRequired,
  onMouseOut: _propTypes2.default.func.isRequired,
  slug: _propTypes2.default.string.isRequired,
  format: _propTypes2.default.string.isRequired
};

var SidebarDownloadDocButtonWithHover = (0, _WithHover2.default)(SidebarDownloadDocButton);

exports.default = SidebarDownloadDocButtonWithHover;

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RankBrain2SidebarToggleButton = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WithHover = __webpack_require__(124);

var _WithHover2 = _interopRequireDefault(_WithHover);

var _Responsive = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var imgStyle = {
  width: 18,
  marginRight: 13
};

var textStyle = {
  display: 'inline',
  verticalAlign: 'middle'
};

var RankBrain2SidebarToggleButton = exports.RankBrain2SidebarToggleButton = function RankBrain2SidebarToggleButton(props) {
  var imgSrc = props.isHover ? props.hoverImgSrc : props.imgSrc;

  return _react2.default.createElement(
    'button',
    {
      className: 'rank-brain-2-sidebar-toggle-button ' + props.className,
      onClick: props.toggleSideBar,
      onMouseOver: props.onMouseOver,
      onMouseOut: props.onMouseOut
    },
    _react2.default.createElement('img', { alt: 'Click to toggle', style: imgStyle, src: imgSrc }),
    _react2.default.createElement(
      _Responsive.DesktopAndTablet,
      null,
      props.includeText && _react2.default.createElement(
        'h3',
        { style: textStyle },
        'SECTIONS'
      )
    )
  );
};

RankBrain2SidebarToggleButton.defaultProps = {
  isHover: false,
  includeText: true,
  className: 'pull-right'
};

RankBrain2SidebarToggleButton.propTypes = {
  className: _propTypes2.default.string,
  onMouseOut: _propTypes2.default.func.isRequired,
  onMouseOver: _propTypes2.default.func.isRequired,
  toggleSideBar: _propTypes2.default.func.isRequired,
  isHover: _propTypes2.default.bool,
  includeText: _propTypes2.default.bool,
  imgSrc: _propTypes2.default.string.isRequired,
  hoverImgSrc: _propTypes2.default.string.isRequired
};

var RankBrain2SidebarToggleButtonWithHover = (0, _WithHover2.default)(RankBrain2SidebarToggleButton);

exports.default = RankBrain2SidebarToggleButtonWithHover;

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(0);

// Sources: https://usehooks.com/useOnScreen and https://css-tricks.com/using-intersectionobserver-to-check-if-page-scrolled-past-certain-point/
var useScrolledPast = function useScrolledPast() {
  var ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var rootMargin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0px';

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isScrolledPast = _useState2[0],
      setScrolledPast = _useState2[1];

  (0, _react.useEffect)(function () {
    var observer = new IntersectionObserver(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          entry = _ref2[0];

      if (entry.boundingClientRect.y < 0) {
        setScrolledPast(true);
      } else {
        setScrolledPast(false);
      }
    }, {
      rootMargin: rootMargin
    });

    var element = ref.current;
    if (element) {
      observer.observe(element);
    }
    return function () {
      observer.unobserve(element);
    };
  }, []);
  return isScrolledPast;
};

exports.default = useScrolledPast;

/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RankBrain2SidebarToggleButton = __webpack_require__(176);

var _RankBrain2SidebarToggleButton2 = _interopRequireDefault(_RankBrain2SidebarToggleButton);

var _Utils = __webpack_require__(103);

var _SidebarGuideInfoSection = __webpack_require__(523);

var _SidebarGuideInfoSection2 = _interopRequireDefault(_SidebarGuideInfoSection);

var _SidebarDownloadSection = __webpack_require__(520);

var _SidebarDownloadSection2 = _interopRequireDefault(_SidebarDownloadSection);

var _SidebarSingleDownloadSection = __webpack_require__(524);

var _SidebarSingleDownloadSection2 = _interopRequireDefault(_SidebarSingleDownloadSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var navBarContainerStyle = {
  position: 'relative',
  height: '100%',
  right: 0,
  top: 0,
  minWidth: 320,
  zIndex: 1
};

var sectionListContainerStyle = {
  paddingLeft: 30,
  paddingRight: 30,
  height: '100%',
  position: 'relative'
};

var sectionListStyle = {
  listStyle: 'none',
  height: '100%',
  paddingLeft: 0
};

var RankBrain2SidebarNavbar = function (_React$PureComponent) {
  _inherits(RankBrain2SidebarNavbar, _React$PureComponent);

  function RankBrain2SidebarNavbar() {
    _classCallCheck(this, RankBrain2SidebarNavbar);

    return _possibleConstructorReturn(this, (RankBrain2SidebarNavbar.__proto__ || Object.getPrototypeOf(RankBrain2SidebarNavbar)).apply(this, arguments));
  }

  _createClass(RankBrain2SidebarNavbar, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          activeSectionIdx = _props.activeSectionIdx,
          activeSectionItemIdx = _props.activeSectionItemIdx;

      var offset = 0;
      var sections = this.props.sections.map(function (section, idx) {
        var sectionNode = _react2.default.createElement(_SidebarGuideInfoSection2.default, {
          key: section.title,
          toggleProps: _this2.props.toggleProps,
          enableSectionOpen: _this2.props.enableSectionOpen,
          section: section,
          offset: offset,
          sectionOffset: idx,
          activeSectionIdx: activeSectionIdx,
          activeSectionItemIdx: activeSectionItemIdx
        });
        offset += section.sectionItems.length;
        return sectionNode;
      });
      return _react2.default.createElement(
        'div',
        { className: 'rank-brain-2-sidebar-navbar', style: navBarContainerStyle },
        this.props.includeToggleSideBar && _react2.default.createElement(_RankBrain2SidebarToggleButton2.default, this.props.toggleProps),
        this.props.includeExcelDownload && _react2.default.createElement(_SidebarSingleDownloadSection2.default, {
          slug: this.props.slug,
          extension: 'xlsx',
          format: 'excel',
          heading: 'Free Download',
          subheading: (0, _Utils.delimiterSeparatedToTitleCase)('-', this.props.slug),
          text: 'Excel Spreadsheet'
        }),
        _react2.default.createElement(_SidebarDownloadSection2.default, {
          slug: this.props.downloadSlug || this.props.slug
        }),
        _react2.default.createElement(
          'div',
          {
            className: 'rank-brain-2-sidebar-section-container nav-list-section',
            style: sectionListContainerStyle
          },
          _react2.default.createElement(
            'ul',
            { className: 'rank-brain-2-sidebar-section-list', style: sectionListStyle },
            sections
          )
        )
      );
    }
  }]);

  return RankBrain2SidebarNavbar;
}(_react2.default.PureComponent);

exports.default = RankBrain2SidebarNavbar;


RankBrain2SidebarNavbar.defaultProps = {
  activeSectionIdx: 0,
  activeSectionItemIdx: 0,
  downloadSlug: '',
  enableSectionOpen: false,
  includeExcelDownload: '',
  includeToggleSideBar: false,
  sections: []
};

RankBrain2SidebarNavbar.propTypes = {
  activeSectionIdx: _propTypes2.default.number,
  activeSectionItemIdx: _propTypes2.default.number,
  downloadSlug: _propTypes2.default.string,
  enableSectionOpen: _propTypes2.default.bool,
  includeExcelDownload: _propTypes2.default.string,
  includeToggleSideBar: _propTypes2.default.bool,
  sections: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  slug: _propTypes2.default.string.isRequired,
  toggleProps: _propTypes2.default.shape({
    toggleSideBar: _propTypes2.default.func,
    includeText: _propTypes2.default.bool,
    hoverImgSrc: _propTypes2.default.string,
    imgSrc: _propTypes2.default.string
  }).isRequired
};

/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(20);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SidebarDownloadDocButton = __webpack_require__(175);

var _SidebarDownloadDocButton2 = _interopRequireDefault(_SidebarDownloadDocButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sidebarSectionContainerStyle = {
  display: 'flex',
  alignItems: 'center',
  paddingLeft: 30,
  paddingRight: 30,
  paddingTop: 25,
  paddingBottom: 25
};

var RankBrain2EditorialDownloadSection = function (_React$PureComponent) {
  _inherits(RankBrain2EditorialDownloadSection, _React$PureComponent);

  function RankBrain2EditorialDownloadSection() {
    _classCallCheck(this, RankBrain2EditorialDownloadSection);

    return _possibleConstructorReturn(this, (RankBrain2EditorialDownloadSection.__proto__ || Object.getPrototypeOf(RankBrain2EditorialDownloadSection)).apply(this, arguments));
  }

  _createClass(RankBrain2EditorialDownloadSection, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          {
            className: 'section-container editorial-download-banner',
            style: sidebarSectionContainerStyle
          },
          _react2.default.createElement(
            'h4',
            null,
            'Download a Free ',
            this.props.documentName
          ),
          _react2.default.createElement(_SidebarDownloadDocButton2.default, {
            slug: this.props.downloadSlug || this.props.slug,
            imgSrc: '/images/rank-brain-2/download-word-2x.png',
            imgSrcHover: '/images/rank-brain-2/download-word-hover-2x.png',
            text: 'Word',
            format: 'docx'
          }),
          _react2.default.createElement(_SidebarDownloadDocButton2.default, {
            slug: this.props.downloadSlug || this.props.slug,
            imgSrc: '/images/rank-brain-2/download-pdf-2x.png',
            imgSrcHover: '/images/rank-brain-2/download-pdf-hover-2x.png',
            text: 'PDF',
            format: 'pdf'
          })
        )
      );
    }
  }], [{
    key: 'init',
    value: function init(id, props) {
      _reactDom2.default.render(_react2.default.createElement(RankBrain2EditorialDownloadSection, props), document.getElementById(id));
    }
  }]);

  return RankBrain2EditorialDownloadSection;
}(_react2.default.PureComponent);

RankBrain2EditorialDownloadSection.defaultProps = {
  downloadSlug: '',
  documentName: ''
};

RankBrain2EditorialDownloadSection.propTypes = {
  slug: _propTypes2.default.string.isRequired,
  documentName: _propTypes2.default.string.isRequired,
  downloadSlug: _propTypes2.default.string
};

exports.default = RankBrain2EditorialDownloadSection;

/***/ }),

/***/ 447:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(20);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _RankBrain2SidebarNavbar = __webpack_require__(254);

var _RankBrain2SidebarNavbar2 = _interopRequireDefault(_RankBrain2SidebarNavbar);

var _RankBrain2SidebarToggleButton = __webpack_require__(176);

var _RankBrain2SidebarToggleButton2 = _interopRequireDefault(_RankBrain2SidebarToggleButton);

var _Responsive = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RankBrain2SidebarLanding = function (_React$Component) {
  _inherits(RankBrain2SidebarLanding, _React$Component);

  _createClass(RankBrain2SidebarLanding, null, [{
    key: 'init',
    value: function init(id, props) {
      _reactDom2.default.render(_react2.default.createElement(RankBrain2SidebarLanding, props), document.getElementById(id));
    }
  }]);

  function RankBrain2SidebarLanding(props) {
    _classCallCheck(this, RankBrain2SidebarLanding);

    var _this = _possibleConstructorReturn(this, (RankBrain2SidebarLanding.__proto__ || Object.getPrototypeOf(RankBrain2SidebarLanding)).call(this, props));

    _this.state = {
      isSideBarOpen: false
    };

    _this.toggleSideBar = _this.toggleSideBar.bind(_this);
    return _this;
  }

  _createClass(RankBrain2SidebarLanding, [{
    key: 'toggleSideBar',
    value: function toggleSideBar() {
      this.setState({
        isSideBarOpen: !this.state.isSideBarOpen
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var sidebar = _react2.default.createElement(_RankBrain2SidebarToggleButton2.default, {
        toggleSideBar: this.toggleSideBar,
        className: 'pull-right btn rank-brain-2-sidebar-toggle-button-landing',
        hoverImgSrc: '/images/rank-brain-2/icon-sections-white-2x.png',
        imgSrc: '/images/rank-brain-2/icon-sections-white-2x.png'
      });
      var toggleProps = {
        toggleSideBar: this.toggleSideBar,
        includeText: false,
        hoverImgSrc: '/images/rank-brain-2/close-hover.png',
        imgSrc: 'images/rank-brain-2/close-default.png'
      };

      var sidebarClass = 'rank-brain-2-sidebar-landing';
      if (this.state.isSideBarOpen) {
        sidebar = _react2.default.createElement(_RankBrain2SidebarNavbar2.default, _extends({}, this.props, {
          toggleProps: toggleProps,
          includeToggleSideBar: true
        }));

        sidebarClass = 'rank-brain-2-sidebar-landing sidebar-expanded';
      }
      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          _Responsive.Desktop,
          null,
          _react2.default.createElement(
            'div',
            { className: sidebarClass + ' rank-brain-2-sidebar-landing-desktop' },
            _react2.default.createElement(_RankBrain2SidebarNavbar2.default, _extends({ toggleProps: toggleProps }, this.props))
          )
        ),
        _react2.default.createElement(
          _Responsive.Tablet,
          null,
          _react2.default.createElement(
            'div',
            { className: sidebarClass + ' rank-brain-2-sidebar-landing-tablet' },
            sidebar
          )
        ),
        _react2.default.createElement(
          _Responsive.Mobile,
          null,
          _react2.default.createElement(
            'div',
            { className: sidebarClass + ' rank-brain-2-sidebar-landing-mobile' },
            sidebar
          )
        )
      );
    }
  }]);

  return RankBrain2SidebarLanding;
}(_react2.default.Component);

exports.default = RankBrain2SidebarLanding;

/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(20);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RankBrain2SidebarNavbar = __webpack_require__(254);

var _RankBrain2SidebarNavbar2 = _interopRequireDefault(_RankBrain2SidebarNavbar);

var _RankBrain2SidebarToggleButton = __webpack_require__(176);

var _RankBrain2SidebarToggleButton2 = _interopRequireDefault(_RankBrain2SidebarToggleButton);

var _useScrolledPast = __webpack_require__(252);

var _useScrolledPast2 = _interopRequireDefault(_useScrolledPast);

var _NavbarHeader = __webpack_require__(525);

var _NavbarHeader2 = _interopRequireDefault(_NavbarHeader);

var _SectionItemTrigger = __webpack_require__(526);

var _SectionItemTrigger2 = _interopRequireDefault(_SectionItemTrigger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var navBarContainerStyle = {
  width: '100%',
  position: 'fixed',
  left: 0,
  top: 0,
  zIndex: 2
};

var navBarStyle = {
  position: 'relative',
  zIndex: 10,
  paddingTop: 26,
  paddingBottom: 26
};

var baseSidebarStyle = {
  position: 'fixed',
  right: 0,
  top: 100,
  height: '100%',
  flexDirection: 'column',
  paddingBottom: 70
};

var RankBrain2StickyNavbar = function RankBrain2StickyNavbar(_ref) {
  var slug = _ref.slug,
      documentName = _ref.documentName,
      dropDownSelection = _ref.dropDownSelection,
      sections = _ref.sections;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isSideBarOpen = _useState2[0],
      setIsSideBarOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      activeSectionIdx = _useState4[0],
      setActiveSectionIdx = _useState4[1];

  var _useState5 = (0, _react.useState)(0),
      _useState6 = _slicedToArray(_useState5, 2),
      activeSectionItemIdx = _useState6[0],
      setActiveSectionItemIdx = _useState6[1];

  var navbarTriggerRef = (0, _react.useRef)(null);
  var isNavBarVisible = (0, _useScrolledPast2.default)(navbarTriggerRef);

  var toggleSideBar = function toggleSideBar() {
    setIsSideBarOpen(function (state) {
      return !state;
    });
  };

  var getSideBar = function getSideBar() {
    var sidebarStyle = _extends({}, baseSidebarStyle);
    if (!isSideBarOpen) {
      sidebarStyle.display = 'none';
    }
    return _react2.default.createElement(
      'div',
      { className: 'rank-brain-2-sticky-sidebar-navbar-container', style: sidebarStyle },
      _react2.default.createElement(_RankBrain2SidebarNavbar2.default, {
        enableSectionOpen: true,
        toggleProps: { toggleSideBar: toggleSideBar },
        activeSectionIdx: activeSectionIdx,
        activeSectionItemIdx: activeSectionItemIdx,
        slug: slug,
        documentName: documentName,
        dropDownSelection: dropDownSelection,
        sections: sections
      })
    );
  };

  var getSideBarButton = function getSideBarButton() {
    if (isSideBarOpen) {
      return _react2.default.createElement(_RankBrain2SidebarToggleButton2.default, {
        className: 'rank-brain-2-sidebar-toggle-button-sticky-open',
        toggleSideBar: toggleSideBar,
        hoverImgSrc: window.formswiftUrl + '/images/rank-brain-2/close-hover.png',
        imgSrc: window.formswiftUrl + '/images/rank-brain-2/close-default.png'
      });
    }

    return _react2.default.createElement(_RankBrain2SidebarToggleButton2.default, {
      className: 'rank-brain-2-sidebar-toggle-button-sticky-close',
      toggleSideBar: toggleSideBar,
      hoverImgSrc: window.formswiftUrl + '/images/rank-brain-2/icon-sections-hover-2x.png',
      imgSrc: window.formswiftUrl + '/images/rank-brain-2/icon-sections-2x.png'
    });
  };

  var navBarContainerStyleToUse = _extends({}, navBarContainerStyle);

  if (!isNavBarVisible) {
    navBarContainerStyleToUse.display = 'none';
  }

  var offset = 0;

  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(
      'div',
      { className: 'rank-brain-2-sticky-navbar-container', style: navBarContainerStyleToUse },
      _react2.default.createElement(
        'div',
        {
          className: 'rank-brain-2-sticky-navbar',
          style: navBarStyle
        },
        _react2.default.createElement(_NavbarHeader2.default, {
          documentName: documentName,
          dropDownSelection: dropDownSelection,
          slug: slug
        }),
        getSideBarButton()
      ),
      getSideBar()
    ),
    _react2.default.createElement('div', { ref: navbarTriggerRef }),
    sections.map(function (section, sectionIdx) {
      var sectionItemTriggers = _react2.default.createElement(
        _react2.default.Fragment,
        { key: section.idTarget },
        section.sectionItems.map(function (sectionItem, sectionItemIdx) {
          return _react2.default.createElement(_SectionItemTrigger2.default, {
            key: sectionItem.idTarget,
            sectionItemOffset: offset,
            sectionIdx: sectionIdx,
            sectionItem: sectionItem,
            sectionItemIdx: sectionItemIdx,
            setActiveSectionIdx: setActiveSectionIdx,
            setActiveSectionItemIdx: setActiveSectionItemIdx
          });
        })
      );
      offset += section.sectionItems.length;
      return sectionItemTriggers;
    })
  );
};

RankBrain2StickyNavbar.init = function (id, props) {
  _reactDom2.default.render(_react2.default.createElement(RankBrain2StickyNavbar, props), document.getElementById(id));
};

RankBrain2StickyNavbar.propTypes = {
  slug: _propTypes2.default.string.isRequired,
  documentName: _propTypes2.default.string.isRequired,
  dropDownSelection: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    name: _propTypes2.default.string
  })).isRequired,
  sections: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    idTarget: _propTypes2.default.string,
    iconSrc: _propTypes2.default.string,
    iconSrcHover: _propTypes2.default.string,
    sectionItems: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      title: _propTypes2.default.string,
      idTarget: _propTypes2.default.string
    }))
  })).isRequired
};

exports.default = RankBrain2StickyNavbar;

/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(20);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SidebarDownloadDocButton = __webpack_require__(175);

var _SidebarDownloadDocButton2 = _interopRequireDefault(_SidebarDownloadDocButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RankBrain3LandingDownloadSection = function RankBrain3LandingDownloadSection(props) {
  return _react2.default.createElement(
    'div',
    {
      className: 'rank-brain-3-landing-download-section-container section-container'
    },
    _react2.default.createElement(
      'div',
      { className: 'rank-brain-3-download-doc-container' },
      _react2.default.createElement(
        'div',
        { className: 'download-label' },
        'Word'
      ),
      _react2.default.createElement(_SidebarDownloadDocButton2.default, {
        slug: props.slug,
        imgSrc: '/images/rank-brain-3/download-word-2x.png',
        imgSrcHover: '/images/rank-brain-3/download-word-hover-2x.png',
        text: '',
        format: 'docx'
      })
    ),
    _react2.default.createElement(
      'div',
      { className: 'rank-brain-3-download-doc-container' },
      _react2.default.createElement(
        'div',
        { className: 'download-label' },
        'PDF'
      ),
      _react2.default.createElement(_SidebarDownloadDocButton2.default, {
        slug: props.slug,
        imgSrc: '/images/rank-brain-3/download-pdf-2x.png',
        imgSrcHover: '/images/rank-brain-3/download-pdf-hover-2x.png',
        text: '',
        format: 'pdf'
      })
    )
  );
};

RankBrain3LandingDownloadSection.init = function (id, props) {
  _reactDom2.default.render(_react2.default.createElement(RankBrain3LandingDownloadSection, props), document.getElementById(id));
};

exports.default = RankBrain3LandingDownloadSection;


RankBrain3LandingDownloadSection.propTypes = {
  slug: _propTypes2.default.string.isRequired
};

/***/ }),

/***/ 456:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(20);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _Responsive = __webpack_require__(25);

var _LinkWithHashChange = __webpack_require__(102);

var _LinkWithHashChange2 = _interopRequireDefault(_LinkWithHashChange);

var _useScrolledPast = __webpack_require__(252);

var _useScrolledPast2 = _interopRequireDefault(_useScrolledPast);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TaxStickyBar = function TaxStickyBar(_ref) {
  var ctaLink = _ref.ctaLink,
      documentName = _ref.documentName,
      secondaryCtaDocName = _ref.secondaryCtaDocName,
      secondaryCtaLink = _ref.secondaryCtaLink,
      taxYearProp = _ref.taxYear;

  var navbarTriggerRef = (0, _react.useRef)(null);
  var isStickyBarVisible = (0, _useScrolledPast2.default)(navbarTriggerRef);

  var navBarContainerStyle = {
    width: '100%',
    position: 'fixed',
    left: 0,
    top: 0,
    zIndex: 2
  };

  var navBarStyle = {
    position: 'relative',
    zIndex: 10,
    paddingTop: 10,
    paddingBottom: 10
  };

  var linkCommonProps = {
    isDynamic: true,
    spy: true,
    duration: 500
  };

  if (!isStickyBarVisible) {
    navBarContainerStyle.display = 'none';
  }

  var desktopText = 'Fill Out ' + documentName + ' for ' + taxYearProp;
  desktopText = secondaryCtaLink ? 'Fill Out Form ' + documentName : desktopText;
  var mobileText = secondaryCtaDocName ? '' + documentName : 'Fill Out ' + documentName;
  var secondaryCtaDesktopText = 'Fill Out Form ' + secondaryCtaDocName;
  var secondaryCtaMobileText = '' + secondaryCtaDocName;
  var mobileFaqText = secondaryCtaDocName ? 'FAQs' : 'Back to FAQs';
  var secondaryCtaClassNames = (0, _classnames2.default)('btn', 'btn-primary', 'btn-lg', 'head-term-state-dropdown-button', 'with-padding', 'with-nec-cta', 'inline-nec-cta');

  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(
      'div',
      { className: 'tax-lp-sticky-bar-container', style: navBarContainerStyle },
      _react2.default.createElement(
        'div',
        {
          className: 'tax-lp-sticky-bar',
          style: navBarStyle
        },
        _react2.default.createElement(
          'div',
          { className: 'formswift-logo' },
          _react2.default.createElement(
            'a',
            { href: '/' },
            _react2.default.createElement('img', { alt: 'FormSwift', src: '/images/logo-on-white.svg' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'builder-button' },
          secondaryCtaLink && _react2.default.createElement(
            'a',
            {
              className: secondaryCtaClassNames,
              href: secondaryCtaLink
            },
            _react2.default.createElement(
              _Responsive.DesktopAndTablet,
              null,
              secondaryCtaDesktopText
            ),
            _react2.default.createElement(
              _Responsive.Mobile,
              null,
              secondaryCtaMobileText
            )
          ),
          _react2.default.createElement(
            'a',
            {
              href: ctaLink,
              className: 'btn btn-success btn-lg head-term-state-dropdown-button with-padding'
            },
            _react2.default.createElement(
              _Responsive.DesktopAndTablet,
              null,
              desktopText
            ),
            _react2.default.createElement(
              _Responsive.Mobile,
              null,
              mobileText
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'back-to-faq' },
          _react2.default.createElement(
            _Responsive.Desktop,
            null,
            _react2.default.createElement(
              _LinkWithHashChange2.default,
              _extends({
                smooth: true,
                to: 'frequentlyAskedQuestionsDesktop'
              }, linkCommonProps),
              'Back to FAQs'
            )
          ),
          _react2.default.createElement(
            _Responsive.MobileAndTablet,
            null,
            _react2.default.createElement(
              _LinkWithHashChange2.default,
              _extends({
                smooth: true,
                to: 'frequentlyAskedQuestionsMobile'
              }, linkCommonProps),
              mobileFaqText
            )
          )
        )
      )
    ),
    _react2.default.createElement('div', { ref: navbarTriggerRef })
  );
};

TaxStickyBar.init = function (id, props) {
  _reactDom2.default.render(_react2.default.createElement(TaxStickyBar, props), document.getElementById(id));
};

TaxStickyBar.defaultProps = {
  secondaryCtaDocName: '',
  secondaryCtaLink: ''
};

TaxStickyBar.propTypes = {
  ctaLink: _propTypes2.default.string.isRequired,
  documentName: _propTypes2.default.string.isRequired,
  secondaryCtaDocName: _propTypes2.default.string,
  secondaryCtaLink: _propTypes2.default.string,
  taxYear: _propTypes2.default.string.isRequired
};

exports.default = TaxStickyBar;

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _RankBrain2StickyNavbar = __webpack_require__(448);

var _RankBrain2StickyNavbar2 = _interopRequireDefault(_RankBrain2StickyNavbar);

var _TaxStickyBar = __webpack_require__(456);

var _TaxStickyBar2 = _interopRequireDefault(_TaxStickyBar);

var _RankBrain2SidebarLanding = __webpack_require__(447);

var _RankBrain2SidebarLanding2 = _interopRequireDefault(_RankBrain2SidebarLanding);

var _RankBrain2EditorialDownloadSection = __webpack_require__(446);

var _RankBrain2EditorialDownloadSection2 = _interopRequireDefault(_RankBrain2EditorialDownloadSection);

var _RankBrain3LandingDownloadSection = __webpack_require__(449);

var _RankBrain3LandingDownloadSection2 = _interopRequireDefault(_RankBrain3LandingDownloadSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.RankBrain2StickyNavbar = _RankBrain2StickyNavbar2.default;
window.TaxStickyBar = _TaxStickyBar2.default;
window.RankBrain2SidebarLanding = _RankBrain2SidebarLanding2.default;
window.RankBrain2EditorialDownloadSection = _RankBrain2EditorialDownloadSection2.default;
window.RankBrain3LandingDownloadSection = _RankBrain3LandingDownloadSection2.default;

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(0);

// Source: https://usehooks.com/useOnScreen
var useOnScreen = function useOnScreen() {
  var ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var domElement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var rootMargin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0px';

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isIntersecting = _useState2[0],
      setIntersecting = _useState2[1];

  (0, _react.useEffect)(function () {
    var observer = new IntersectionObserver(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          entry = _ref2[0];

      setIntersecting(entry.isIntersecting);
    }, {
      rootMargin: rootMargin
    });
    var element = ref.current || domElement;
    if (element) {
      observer.observe(element);
    }
    return function () {
      observer.unobserve(element);
    };
  }, []);
  return isIntersecting;
};

exports.default = useOnScreen;

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SidebarDownloadDocButton = __webpack_require__(175);

var _SidebarDownloadDocButton2 = _interopRequireDefault(_SidebarDownloadDocButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sidebarSectionContainerStyle = {
  display: 'flex',
  alignItems: 'center',
  paddingLeft: 30,
  paddingRight: 30,
  paddingTop: 25,
  paddingBottom: 25
};

var headerStyle = {
  margin: 0
};

var SidebarDownloadSection = function SidebarDownloadSection(props) {
  return _react2.default.createElement(
    'div',
    {
      className: 'rank-brain-2-sidebar-section-container section-container',
      style: sidebarSectionContainerStyle
    },
    _react2.default.createElement(_SidebarDownloadDocButton2.default, {
      slug: props.slug,
      imgSrc: '/images/rank-brain-2/download-word-2x.png',
      imgSrcHover: '/images/rank-brain-2/download-word-hover-2x.png',
      text: 'Word',
      format: 'docx'
    }),
    _react2.default.createElement(_SidebarDownloadDocButton2.default, {
      slug: props.slug,
      imgSrc: '/images/rank-brain-2/download-pdf-2x.png',
      imgSrcHover: '/images/rank-brain-2/download-pdf-hover-2x.png',
      text: 'PDF',
      format: 'pdf'
    }),
    _react2.default.createElement(
      'h3',
      { style: headerStyle },
      'Free Download'
    )
  );
};

exports.default = SidebarDownloadSection;


SidebarDownloadSection.propTypes = {
  slug: _propTypes2.default.string.isRequired
};

/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SidebarGuideInfoSectionTitle = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Responsive = __webpack_require__(25);

var _LinkWithHashChange = __webpack_require__(102);

var _LinkWithHashChange2 = _interopRequireDefault(_LinkWithHashChange);

var _WithHover = __webpack_require__(124);

var _WithHover2 = _interopRequireDefault(_WithHover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var buttonStyle = {
  padding: 0,
  background: 'none',
  border: 'none',
  outline: 'none',
  textAlign: 'left',
  display: 'flex',
  alignItems: 'center',
  marginBottom: 10
};

var imageStyle = {
  height: 42,
  marginRight: 11
};

var SidebarGuideInfoSectionTitle = exports.SidebarGuideInfoSectionTitle = function (_React$Component) {
  _inherits(SidebarGuideInfoSectionTitle, _React$Component);

  function SidebarGuideInfoSectionTitle(props) {
    _classCallCheck(this, SidebarGuideInfoSectionTitle);

    var _this = _possibleConstructorReturn(this, (SidebarGuideInfoSectionTitle.__proto__ || Object.getPrototypeOf(SidebarGuideInfoSectionTitle)).call(this, props));

    _this.renderButton = _this.renderButton.bind(_this);
    _this.renderTitleContent = _this.renderTitleContent.bind(_this);
    return _this;
  }

  _createClass(SidebarGuideInfoSectionTitle, [{
    key: 'renderTitleContent',
    value: function renderTitleContent() {
      var section = this.props.section;


      var imgSrc = this.props.isHover ? section.iconSrcHover : section.iconSrc;
      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement('img', { alt: 'Click to open', src: imgSrc, style: imageStyle }),
        _react2.default.createElement(
          'h3',
          null,
          section.title
        )
      );
    }
  }, {
    key: 'renderButton',
    value: function renderButton() {
      var _props = this.props,
          enableSectionOpen = _props.enableSectionOpen,
          onClick = _props.onClick,
          onMouseOut = _props.onMouseOut,
          onMouseOver = _props.onMouseOver,
          section = _props.section;


      if (enableSectionOpen) {
        return _react2.default.createElement(
          'button',
          {
            className: 'rank-brain-2-sidebar-guide-section-title-button',
            onMouseOver: onMouseOver,
            onMouseOut: onMouseOut,
            style: buttonStyle,
            onClick: onClick
          },
          this.renderTitleContent()
        );
      }

      var commonLinkProps = {
        style: buttonStyle,
        className: 'rank-brain-2-sidebar-guide-section-title-link btn',
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        isDynamic: true,
        to: section.idTarget,
        spy: true,
        offset: -100,
        duration: 500
      };

      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          _Responsive.Desktop,
          null,
          _react2.default.createElement(
            _LinkWithHashChange2.default,
            _extends({
              smooth: true
            }, commonLinkProps),
            this.renderTitleContent()
          )
        ),
        _react2.default.createElement(
          _Responsive.Tablet,
          null,
          _react2.default.createElement(
            _LinkWithHashChange2.default,
            _extends({
              smooth: true
            }, commonLinkProps, {
              onClick: this.props.toggleSideBar
            }),
            this.renderTitleContent()
          )
        ),
        _react2.default.createElement(
          _Responsive.Mobile,
          null,
          _react2.default.createElement(
            _LinkWithHashChange2.default,
            _extends({}, commonLinkProps, {
              onClick: this.props.toggleSideBar
            }),
            this.renderTitleContent()
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return this.renderButton();
    }
  }]);

  return SidebarGuideInfoSectionTitle;
}(_react2.default.Component);

SidebarGuideInfoSectionTitle.defaultProps = {
  section: {},
  enableSectionOpen: false,
  isHover: false,
  onClick: function onClick() {},
  toggleSideBar: function toggleSideBar() {}
};

SidebarGuideInfoSectionTitle.propTypes = {
  enableSectionOpen: _propTypes2.default.bool,
  isHover: _propTypes2.default.bool,
  section: _propTypes2.default.shape({
    title: _propTypes2.default.string,
    iconSrc: _propTypes2.default.string,
    iconSrcHover: _propTypes2.default.string
  }),
  onMouseOver: _propTypes2.default.func.isRequired,
  onMouseOut: _propTypes2.default.func.isRequired,
  onClick: _propTypes2.default.func,
  toggleSideBar: _propTypes2.default.func
};

var SidebarGuideInfoSectionTitleWithHover = (0, _WithHover2.default)(SidebarGuideInfoSectionTitle);

exports.default = SidebarGuideInfoSectionTitleWithHover;

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var listItemTabClassName = (0, _classnames2.default)('rank-brain-2-sidebar-guide-section-tab');

var listItemTabStyle = {
  marginBottom: 11
};

var SidebarGuideTab = function SidebarGuideTab(props) {
  var title = props.sectionItem.title;
  return _react2.default.createElement(
    'li',
    {
      className: listItemTabClassName,
      style: listItemTabStyle,
      key: title
    },
    _react2.default.createElement(
      'span',
      null,
      title
    )
  );
};

SidebarGuideTab.defaultProps = {
  sectionItem: {}
};

SidebarGuideTab.propTypes = {
  sectionItem: _propTypes2.default.shape({
    title: _propTypes2.default.string
  })
};

exports.default = SidebarGuideTab;

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _Responsive = __webpack_require__(25);

var _LinkWithHashChange = __webpack_require__(102);

var _LinkWithHashChange2 = _interopRequireDefault(_LinkWithHashChange);

var _SidebarGuideInfoSectionTitle = __webpack_require__(521);

var _SidebarGuideInfoSectionTitle2 = _interopRequireDefault(_SidebarGuideInfoSectionTitle);

var _SidebarGuideTab = __webpack_require__(522);

var _SidebarGuideTab2 = _interopRequireDefault(_SidebarGuideTab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sectionContentStyle = {
  marginTop: 24
};

var listItemContainerStyle = {
  listStyle: 'none',
  paddingLeft: 51
};

var listItemStyle = {
  marginBottom: 11,
  paddingBottom: 13
};

var arrowRightStyle = {
  borderBottom: '12px solid transparent',
  borderLeft: '12px solid #66748A',
  borderTop: '12px solid transparent',
  height: 0,
  left: 0,
  position: 'absolute',
  width: 0
};

var SidebarGuideInfoSection = function (_React$Component) {
  _inherits(SidebarGuideInfoSection, _React$Component);

  function SidebarGuideInfoSection(props) {
    _classCallCheck(this, SidebarGuideInfoSection);

    var _this = _possibleConstructorReturn(this, (SidebarGuideInfoSection.__proto__ || Object.getPrototypeOf(SidebarGuideInfoSection)).call(this, props));

    _this.state = {
      manuallySet: false,
      open: false
    };

    _this.onClick = _this.onClick.bind(_this);
    _this.isOpen = _this.isOpen.bind(_this);
    _this.renderSection = _this.renderSection.bind(_this);
    _this.renderSectionItems = _this.renderSectionItems.bind(_this);
    return _this;
  }

  _createClass(SidebarGuideInfoSection, [{
    key: 'onClick',
    value: function onClick() {
      this.setState({
        manuallySet: true,
        open: !this.isOpen()
      });
    }
  }, {
    key: 'isOpen',
    value: function isOpen() {
      var manuallyOpen = this.state.manuallySet && this.state.open;
      var automaticOpen = !this.state.manuallySet && this.props.activeSectionIdx === this.props.sectionOffset;
      return manuallyOpen || automaticOpen;
    }
  }, {
    key: 'renderSectionItems',
    value: function renderSectionItems() {
      var _props = this.props,
          activeSectionItemIdx = _props.activeSectionItemIdx,
          enableSectionOpen = _props.enableSectionOpen,
          offset = _props.offset,
          section = _props.section,
          toggleProps = _props.toggleProps;


      var className = (0, _classnames2.default)('rank-brain-2-sidebar-guide-section-item-list', {
        hidden: !this.isOpen() || !enableSectionOpen
      });

      return _react2.default.createElement(
        'ul',
        { className: className, style: listItemContainerStyle },
        section.sectionItems.map(function (sectionItem, idx) {
          var listItemClassName = (0, _classnames2.default)('rank-brain-2-sidebar-guide-section-item', {
            active: activeSectionItemIdx === offset + idx
          });

          var linkProps = {
            isDynamic: true,
            to: sectionItem.idTarget,
            spy: true,
            offset: -100,
            duration: 500
          };

          var arrowRight = null;
          if (activeSectionItemIdx === offset + idx) {
            arrowRight = _react2.default.createElement('div', { className: 'arrow-right', style: arrowRightStyle });
          }

          if (!sectionItem.idTarget && sectionItem.type === 'tab') {
            return _react2.default.createElement(_SidebarGuideTab2.default, { sectionItem: sectionItem });
          }

          return _react2.default.createElement(
            'li',
            { className: listItemClassName, style: listItemStyle, key: sectionItem.title },
            _react2.default.createElement(
              _Responsive.Desktop,
              null,
              _react2.default.createElement(
                _LinkWithHashChange2.default,
                _extends({
                  smooth: true
                }, linkProps),
                arrowRight,
                _react2.default.createElement(
                  'span',
                  null,
                  sectionItem.title
                )
              )
            ),
            _react2.default.createElement(
              _Responsive.Tablet,
              null,
              _react2.default.createElement(
                _LinkWithHashChange2.default,
                _extends({
                  smooth: true
                }, linkProps, {
                  onClick: toggleProps.toggleSideBar
                }),
                arrowRight,
                _react2.default.createElement(
                  'span',
                  null,
                  sectionItem.title
                )
              )
            ),
            _react2.default.createElement(
              _Responsive.Mobile,
              null,
              _react2.default.createElement(
                _LinkWithHashChange2.default,
                _extends({}, linkProps, {
                  onClick: toggleProps.toggleSideBar
                }),
                arrowRight,
                _react2.default.createElement(
                  'span',
                  null,
                  sectionItem.title
                )
              )
            )
          );
        })
      );
    }
  }, {
    key: 'renderSection',
    value: function renderSection() {
      var section = this.props.section;

      return _react2.default.createElement(
        'li',
        {
          key: section.title,
          className: 'rank-brain-2-sidebar-guide-section'
        },
        _react2.default.createElement(
          'div',
          { style: sectionContentStyle },
          _react2.default.createElement(_SidebarGuideInfoSectionTitle2.default, _extends({}, this.props, {
            onClick: this.onClick
          })),
          this.renderSectionItems()
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return this.renderSection();
    }
  }]);

  return SidebarGuideInfoSection;
}(_react2.default.Component);

exports.default = SidebarGuideInfoSection;


SidebarGuideInfoSection.defaultProps = {
  section: {},
  enableSectionOpen: false
};

SidebarGuideInfoSection.propTypes = {
  enableSectionOpen: _propTypes2.default.bool,
  section: _propTypes2.default.shape({}),
  sectionOffset: _propTypes2.default.number.isRequired,
  offset: _propTypes2.default.number.isRequired,
  activeSectionIdx: _propTypes2.default.number.isRequired,
  activeSectionItemIdx: _propTypes2.default.number.isRequired,
  toggleProps: _propTypes2.default.shape({
    toggleSideBar: _propTypes2.default.func,
    includeText: _propTypes2.default.bool,
    hoverImgSrc: _propTypes2.default.string,
    imgSrc: _propTypes2.default.string
  }).isRequired
};

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SidebarSingleDownloadSection = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WithHover = __webpack_require__(124);

var _WithHover2 = _interopRequireDefault(_WithHover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buttonStyle = {
  background: 'none',
  border: 'none',
  display: 'flex',
  outline: 'none',
  padding: 0
};

var imgStyle = {
  alignSelf: 'flex-end',
  height: 98,
  marginRight: 20
};

var sidebarSectionContainerStyle = {
  display: 'flex',
  paddingLeft: 30,
  paddingRight: 30,
  paddingTop: 30
};

var SidebarSingleDownloadSection = exports.SidebarSingleDownloadSection = function SidebarSingleDownloadSection(props) {
  var imgSrc = '/images/rank-brain-2/download-' + props.format + '-2x.png';
  if (props.isHover) {
    imgSrc = '/images/rank-brain-2/download-' + props.format + '-hover-2x.png';
  }

  return _react2.default.createElement(
    'div',
    {
      className: 'rank-brain-2-sidebar-section-container single-download-sample-section',
      style: sidebarSectionContainerStyle,
      onMouseOver: props.onMouseOver,
      onMouseOut: props.onMouseOut
    },
    _react2.default.createElement(
      'a',
      {
        style: buttonStyle,
        rel: 'noreferrer noopener',
        download: true,
        href: window.cdnUrl + '/downloads/' + props.slug + '/' + props.slug + '.' + props.extension
      },
      _react2.default.createElement('img', {
        alt: 'Download',
        style: imgStyle,
        src: imgSrc
      }),
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h3',
          null,
          props.heading
        ),
        _react2.default.createElement(
          'p',
          null,
          props.subheading
        ),
        _react2.default.createElement(
          'i',
          null,
          props.text
        )
      )
    )
  );
};

SidebarSingleDownloadSection.defaultProps = {
  heading: '',
  isHover: false,
  subheading: '',
  text: ''
};

SidebarSingleDownloadSection.propTypes = {
  extension: _propTypes2.default.string.isRequired,
  format: _propTypes2.default.string.isRequired,
  heading: _propTypes2.default.string,
  isHover: _propTypes2.default.bool,
  onMouseOut: _propTypes2.default.func.isRequired,
  onMouseOver: _propTypes2.default.func.isRequired,
  slug: _propTypes2.default.string.isRequired,
  subheading: _propTypes2.default.string,
  text: _propTypes2.default.string
};

var SidebarSingleDownloadSectionWithHover = (0, _WithHover2.default)(SidebarSingleDownloadSection);

exports.default = SidebarSingleDownloadSectionWithHover;

/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Responsive = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavbarHeader = function NavbarHeader(props) {
  return _react2.default.createElement(
    'div',
    {
      className: 'rank-brain-2-sticky-navbar-header'
    },
    _react2.default.createElement(
      'select',
      {
        className: 'head-term-state-dropdown rank-brain-2-state-dropdown form-control'
      },
      props.dropDownSelection.map(function (dropDownOption) {
        return _react2.default.createElement(
          'option',
          { key: dropDownOption.name },
          dropDownOption.name
        );
      })
    ),
    _react2.default.createElement(
      _Responsive.DesktopAndTablet,
      null,
      _react2.default.createElement(
        'a',
        {
          className: 'btn btn-success btn-lg head-term-state-dropdown-button rank-brain-2-state-dropdown-button with-padding',
          href: '/builder.php?documentType=' + props.slug
        },
        'Create My Document'
      )
    ),
    _react2.default.createElement(
      _Responsive.Mobile,
      null,
      _react2.default.createElement(
        'a',
        {
          className: 'btn btn-success btn-lg head-term-state-dropdown-button rank-brain-2-state-dropdown-button with-padding',
          href: '/builder.php?documentType=' + props.slug
        },
        'Create'
      )
    )
  );
};

NavbarHeader.propTypes = {
  documentName: _propTypes2.default.string.isRequired,
  slug: _propTypes2.default.string.isRequired,
  dropDownSelection: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    name: _propTypes2.default.string
  })).isRequired
};

exports.default = NavbarHeader;

/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _useOnScreen = __webpack_require__(479);

var _useOnScreen2 = _interopRequireDefault(_useOnScreen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SectionItemTrigger = function SectionItemTrigger(_ref) {
  var sectionIdx = _ref.sectionIdx,
      sectionItem = _ref.sectionItem,
      sectionItemIdx = _ref.sectionItemIdx,
      sectionItemOffset = _ref.sectionItemOffset,
      setActiveSectionIdx = _ref.setActiveSectionIdx,
      setActiveSectionItemIdx = _ref.setActiveSectionItemIdx;

  var target = document.getElementById(sectionItem.idTarget);
  var isSectionItemVisible = (0, _useOnScreen2.default)({}, target, '-51px 0px -85% 0px');

  (0, _react.useEffect)(function () {
    if (isSectionItemVisible) {
      setActiveSectionIdx(sectionIdx);
      setActiveSectionItemIdx(sectionItemOffset + sectionItemIdx);
    }
  }, [isSectionItemVisible]);

  return null;
};

SectionItemTrigger.propTypes = {
  sectionIdx: _propTypes2.default.number.isRequired,
  sectionItem: _propTypes2.default.shape({
    title: _propTypes2.default.string,
    idTarget: _propTypes2.default.string
  }).isRequired,
  sectionItemIdx: _propTypes2.default.number.isRequired,
  sectionItemOffset: _propTypes2.default.number.isRequired,
  setActiveSectionIdx: _propTypes2.default.func.isRequired,
  setActiveSectionItemIdx: _propTypes2.default.func.isRequired
};

exports.default = SectionItemTrigger;

/***/ })

},[468]);


// WEBPACK FOOTER //
// seo-rank-brain-2.js